function adjustMicrocopy() {
  document.querySelectorAll('.lp202610__microcopy').forEach(el => {
    let fontSize = window.innerWidth <= 767 ? 28 : 40;
    el.style.fontSize = fontSize + 'px';

    while (el.scrollWidth > el.clientWidth && fontSize > 12) {
      fontSize--;
      el.style.fontSize = fontSize + 'px';
    }
  });
}

document.addEventListener('DOMContentLoaded', adjustMicrocopy);
window.addEventListener('resize', adjustMicrocopy);



document.addEventListener('DOMContentLoaded', () => {
  const fixedBtn = document.querySelector('[data-lp202610-fixed-button]') || document.querySelector('.lp202610__fixed-button');
  const ctas = document.querySelectorAll('.lp202610__cta');

  if (!fixedBtn || ctas.length === 0) return;

  fixedBtn.addEventListener('click', (e) => {
    e.preventDefault(); 

    let closestCta = null;
    let minDistance = Infinity;

    
    ctas.forEach(cta => {
      const rect = cta.getBoundingClientRect();
      const ctaCenter = rect.top + (rect.height / 2);
      const windowCenter = window.innerHeight / 2;
      const distance = Math.abs(ctaCenter - windowCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestCta = cta;
      }
    });

    
    if (closestCta) {
      closestCta.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
});